var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MonitorLayoutTemplate", {
    attrs: { table_title: _vm.table_title, title_size: 18 },
    scopedSlots: _vm._u([
      {
        key: "datetime",
        fn: function() {
          return [
            _c("QpeDatetime", {
              attrs: { props_date: _vm.date, props_time: _vm.time },
              on: {
                "update-time": _vm.update_time,
                "change-parent-date-time": _vm.change_parent_date_time
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "data_table",
        fn: function(slot_props) {
          return [
            _c("QpeDatatable", {
              attrs: {
                data: _vm.table_data,
                headers: _vm.header,
                name: _vm.default_value,
                error_text: _vm.error_text,
                props_date: _vm.date,
                props_time: _vm.time,
                search: slot_props.search,
                should_show_raw_html_header: _vm.should_show_raw_html_header,
                show_download_pdf_btn: _vm.show_download_pdf_btn
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "table_description",
                    fn: function() {
                      return [
                        _c("span", [
                          _vm._v(
                            '\n                    說明："--"標示，顯示該欄位無資料。'
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t("__monitor.min_10_gust_annotation"))
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t("__monitor.hour_1_gust_annotation"))
                          ),
                          _c("br")
                        ])
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                true
              )
            })
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }